import { IShiftRequestEntity } from "sh-models";
import { mutatorAction } from "satcheljs";
import { shiftRequestStore } from "../";

export default mutatorAction('UPDATE_SHIFT_REQUEST_IN_STORE', function updateShiftRequestInStore(shiftRequest: IShiftRequestEntity) {
    if (shiftRequest && shiftRequest.id) {
        shiftRequestStore().shiftRequests.set(shiftRequest.id, shiftRequest);
    }
});
